import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render top 50 section for FAQ Page
 */
const Top50 = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="top-50-component"
    >
      <AccordionV2
        testId="launch"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="Why top 50?"
            className="px-0 font-medium"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <p className="m-0 px-6 py-2 pt-4">
          We believe that it is a fair representation of enterprises to be
          considered for the award based on Singapore&apos;s size and level of
          business activity. However, we are very open to extending this award
          to a greater number of companies if and when it is appropriate.
        </p>
      </AccordionV2>
    </div>
  );
};

export default Top50;
